import { withInstall } from '@bigin/utils'

import Link from './src/link.vue'

export const BLink = withInstall(Link)
export default BLink

export * from './src/link'
